import { http } from '@/utils/http.js';
import { teamPath } from '@/utils/paths.js';

export const EmailEventsApi = {
  getEvents(id) {
    return http.get(`${teamPath()}/emails/${id}/events`).then((response) => response.data.data);
  },

  getWebhooks(id, eventId) {
    return http
      .get(`${teamPath()}/emails/${id}/callbacks`, { params: { event_id: eventId } })
      .then((response) => response.data.data);
  },
};
